import React, { useEffect, useState } from "react";
import { Effect } from "../../types/effects";
import dreamWorldProvider from "../../DreamWorldProvider";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { selectUserGlobalData } from "../../store/dreamworldSlice";

interface CreatedEffectsProps {
  onEffectClick: (effect: Effect) => void;
}

const CreatedEffects: React.FC<CreatedEffectsProps> = ({ onEffectClick }) => {
  const userGlobalData = useSelector(selectUserGlobalData);
  const [effects, setEffects] = useState<Effect[]>([]);

  useEffect(() => {
    if (userGlobalData) {
      dreamWorldProvider
        .getUserCreatedEffects(userGlobalData.userData.uid)
        .then(setEffects);
    }
  }, [userGlobalData]);

  if (!userGlobalData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {effects.map((effect) => (
          <motion.div
            key={effect.id}
            className="bg-gray-800 rounded-lg shadow-lg cursor-pointer"
            whileHover={{ scale: 1.05 }}
            onClick={() => onEffectClick(effect)}
          >
            <img
              src={effect.image}
              alt={effect.title}
              className="w-full h-48 object-cover rounded-t-lg"
            />
            <div className="p-4">
              <h3 className="text-white font-semibold">{effect.title}</h3>
              <p className="text-gray-400 text-sm mt-1">
                {effect.description}
              </p>
              <p className="text-purple-400 text-xs mt-2">
                Used {effect.useCount} times
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CreatedEffects;
